// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-header[data-v-1f2359a4]{margin-bottom:1em;grid-gap:20px;gap:20px;font-size:20px}@media(min-width:960px){.page-header[data-v-1f2359a4]{font-size:24px}}.page-header h1[data-v-1f2359a4]{margin:0;font-size:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
